/**
 *  TODO(#15): Rename and update typing patterns for MeasurementUnit and UnitOfMeasurement
 */
export var MeasurementUnit;
(function (MeasurementUnit) {
    MeasurementUnit["MM"] = "mm";
    MeasurementUnit["CM"] = "cm";
    MeasurementUnit["M"] = "m";
    MeasurementUnit["IN"] = "in";
    MeasurementUnit["YD"] = "yd";
    MeasurementUnit["FT"] = "ft";
    MeasurementUnit["PT"] = "pt";
})(MeasurementUnit || (MeasurementUnit = {}));
//# sourceMappingURL=types.js.map